// extracted by mini-css-extract-plugin
module.exports = {"container":"table_container__1UTNG","content":"table_content__7jQPX"};